const footerContent = {
    brandName: "Hong Kong Architect",
    address: ["Edvard Thomsens Vej 63 9"],
    copyright: "© 2025 All Rights Reserved",
    socialLinks: {
      instagram: "https://www.instagram.com/hongkongarchitect_/",
    },
  };
  
  export default footerContent;
  